import React from 'react';
import ResponsiveDrawer from '../../components/sidebar/ResponsiveDrawer';

export default function Dashboard() {
  return <ResponsiveDrawer />;
}